import type { Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import type BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import MouvementDupliquerAction from '../../mouvements/liquidation/actions/MouvementDupliquerAction';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import BordereauModifierAction from '../actions/BordereauModifierAction';
import BaseBordereauState from './BaseBordereauState';

class BordereauPrisEnChargeDGFIPState extends BaseBordereauState {
	constructor() {
		super();
		this.step = BordereauStateStep.TRAITE_DGFIP;
		this.state = BordereauStateType.TRAITE_DGFIP;
		this.color = '#70726E';
		this.libelle = 'Traité par la DGFIP';
	}

	getBordereauActions(
		_bordereau: BordereauWithState,
		userRole: UserRole,
	): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
		return [
			new BordereauDupliquerAction(),
			...(userRole === UserRole.ADMIN
				? [new BordereauModifierAction({ isSuperUser: true })]
				: []),
		];
	}

	getMouvementActions(
		userRole: UserRole,
	): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
		return [
			new MouvementModifierAction({ isReadonly: true }),
			new MouvementDupliquerAction(),
			...(userRole === UserRole.ADMIN
				? [new MouvementModifierAction({ isSuperUser: true })]
				: []),
		];
	}
}

export default BordereauPrisEnChargeDGFIPState;
